<template>
  <div class="dropdown-base lk-menu">
    <ul class="dropdown-base-list">
      <!--      <li class="dropdown-base-list__header dropdown-base-list__item">
        <div class="dropdown-base-list__title">Личный кабинет</div>
        <div class="d-flex">
          <a href="/" class="dropdown-base-list__link dropdown-base-list__link&#45;&#45;small">Перейти</a>
          <v-icon size="20" class="dropdown-base__close">{{mdiClose}}</v-icon>
        </div>
      </li>-->
      <li class="dropdown-base-list__item">
        <router-link to="/profile/statements/" class="dropdown-base-list__link"
          >Мои заявления</router-link
        >
      </li>
      <li class="dropdown-base-list__item">
        <router-link
          to="/profile/statements-joint/"
          class="dropdown-base-list__link"
          >Совместные заявления</router-link
        >
      </li>
      <li
        v-if="isOrganizationStatementsVisible"
        class="dropdown-base-list__item"
      >
        <router-link
          :to="{
            name: RouteName.ORGANIZATION_STATEMENTS,
          }"
          class="dropdown-base-list__link"
        >
          Все заявления по организации
        </router-link>
      </li>
      <li class="dropdown-base-list__item">
        <router-link
          to="/profile/notifications-documents/"
          class="dropdown-base-list__link"
        >
          <div class="badge" v-if="newNotificationDocCount">
            <v-badge color="red" dot class="badge-link"
              >Полученные документы</v-badge
            >
          </div>
          <span class="badge badge-link" v-else>Полученные документы</span>
        </router-link>
      </li>
      <li class="dropdown-base-list__item">
        <router-link
          to="/profile/documents-and-data/"
          class="dropdown-base-list__link"
          >Профиль</router-link
        >
      </li>
      <li class="dropdown-base-list__item">
        <router-link
          to="/profile/personal-details/"
          class="dropdown-base-list__link"
          >{{ RouteText.PERSONAL_DETAILS }}</router-link
        >
      </li>
      <!--      <li class="dropdown-base-list__item"><a href="https://notariat.ru/ru-ru/" class="dropdown-base-list__link">Вернуться на сайт Федеральной
        нотариальной палаты</a></li>-->
      <li class="dropdown-base-list__item">
        <a @click="logout" class="dropdown-base-list__link">Выйти</a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mdiClose } from '@mdi/js';
import { AuthModule } from '@/store/modules/auth';
import { NotificationDocModule } from '@/store/modules/notificationsDocuments';
import { RouteText, RouteName } from '@/router';
import { Role } from '@/utils/dictionaries';

export default {
  name: 'LKMenuDropDown',
  data() {
    return {
      RouteName,
      mdiClose,
      RouteText,
    };
  },
  computed: {
    newNotificationDocCount() {
      return NotificationDocModule.newCount;
    },
    isOrganizationStatementsVisible() {
      return AuthModule.roleType === Role.ORGANIZATION || AuthModule.isBusinessman;
    }
  },
  methods: {
    logout() {
      AuthModule.logout();
    },
  },
};
</script>

<style scoped lang="scss"></style>
